import { RootState } from "../../store";
import { AccountId } from "../../../services/cloudchipr.api";

export const prefillAccountIdSelector = (
  state: RootState,
): AccountId | null => {
  return state.accountSetup.prefillAccountId;
};
